var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComponentNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 423 \\u2013 9",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 144753",
    style: {
      fill: "#f3f6fa",
      opacity: 0.001
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173005"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21181",
    d: "M10.7 11.111H4.61a.6.6 0 0 1-.61-.593V4.593A.6.6 0 0 1 4.61 4h6.1a.6.6 0 0 1 .61.593v5.926a.6.6 0 0 1-.62.592z",
    transform: "translate(-2 -2)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21186",
    d: "M10.7 11.111H4.61a.6.6 0 0 1-.61-.593V4.593A.6.6 0 0 1 4.61 4h6.1a.6.6 0 0 1 .61.593v5.926a.6.6 0 0 1-.62.592zM5.3 5.259v4.592h4.724V5.259z",
    transform: "translate(-2 6.889)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21185",
    d: "M10.7 11.111H4.61a.6.6 0 0 1-.61-.593V4.593A.6.6 0 0 1 4.61 4h6.1a.6.6 0 0 1 .61.593v5.926a.6.6 0 0 1-.62.592zM5.3 5.259v4.592h4.724V5.259z",
    transform: "translate(6.686 -2)",
    style: {
      fill: "#203662"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 21187",
    d: "M10.7 11.111H4.61a.6.6 0 0 1-.61-.593V4.593A.6.6 0 0 1 4.61 4h6.1a.6.6 0 0 1 .61.593v5.926a.6.6 0 0 1-.62.592zM5.3 5.259v4.592h4.724V5.259z",
    transform: "translate(6.686 6.889)",
    style: {
      fill: "#203662"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentNewIcon);
export default __webpack_public_path__ + "static/media/ComponentNewIcon.b97e5a786b0401ca636e46cd5c626a84.svg";
export { ForwardRef as ReactComponent };